module.exports = __webpack_public_path__ + "static/media/child_icon_girl.2ac6bbdd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gJunior/child_icon_girl.svg
// module id = 322
// module chunks = 21